import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useFetch = () => {
    const navigate = useNavigate();

    const handleUnauthorized = () => {
        localStorage.removeItem('token');
        navigate('/login');
        throw new Error('Unauthorized access. Please login again.');
    };

    const fetchWithAuth = useCallback(async (url, options = {}) => {
        const token = localStorage.getItem('token');

        if (!token && options.headers?.Authorization) {
            return handleUnauthorized();
        }

        try {
            const response = await fetch(url, options);

            if (response.status === 401 || response.status === 403) {
                return handleUnauthorized();
            }

            return response;
        } catch (error) {
            if (error.message === 'Unauthorized access. Please login again.') {
                throw error;
            }
            throw new Error(error.message || 'Network error');
        }
    }, [navigate]);

    return { fetchWithAuth };
}; 